<script>

import SliderPhoto from '@/components/slider-photo';
import catalog from '@/mixins/catalog';


export default {name:"one-home",

                        props: [
                                'item',
                                'path',
                                'isPlaying'
                            ],
                        components:{"slider-photo": SliderPhoto},
                        mixins:[catalog],
                        data:function(){

                            return {
                                        
                                                            
                                    }
						
                        },
                        mounted() {
                            
                           

                        },

                        created: function(){

           
                           // console.log(this.item);

                        }, 

                        computed: {
							
							
                        },
						methods:{


						
						}

					}

</script>

<template>
    
    <div class="slider-built-cottages__item home-item">
    <a :href="item.DETAIL_PAGE_URL" class="">
                                    <div class="cottages__images-img">
                                        <a :href="item.DETAIL_PAGE_URL" class="">
                                            <slider-photo :item="item" :max-height="174" :is-playing="isPlaying"></slider-photo>
                                        </a>
                                           
                                       
                                    </div>
                                    <div class="built-cottage__content-wrapper">
                                        <div class="built-cottage__content">
                                            <p class="built-cottage__content-title">
                                                <a :href="item.DETAIL_PAGE_URL">{{item.NAME}}</a>
                                            </p>
                                            <div class="built-cottage__content-teg">
                                                <img :src="getPath('icon-map.svg')" alt="Icon">
                                                <a class="built-cottage__gk" href="" v-if="item.JK">  {{ item.JK }} </a>
                                            </div>
                                            <p class="built-cottage__price" v-if="checkPrice(item)">от {{parseInt(item.PROPS.PRICE[0].VALUE) | currency}}</p>
                                        </div>
                                        <div class="built-cottage__details">
                                            <div class="built-cottage__detail">
                                                <p class="built-cottage__details-name">Спальни:</p>
                                                <div class="built-cottage__details-count">{{item.PROPS.ROOMS[0].VALUE}}</div>
                                            </div>
                                            <!--<div class="built-cottage__detail">
                                                <p class="built-cottage__details-name">Санузлов:</p>
                                                <div class="built-cottage__details-count">{{item.PROPS.BATHROOMS[0].VALUE}}</div>
                                            </div>-->
                                            <div class="built-cottage__detail">
                                                <p class="built-cottage__details-name">Этажей:</p>
                                                <div class="built-cottage__details-count">{{item.PROPS.FLOORS[0].VALUE}}</div>
                                            </div>
                                            <div class="built-cottage__detail">
                                                <p class="built-cottage__details-name">Площадь:</p>
                                                <div class="built-cottage__details-count">{{item.PROPS.M2[0].VALUE}} м²</div>
                                            </div>
                                            <div class="built-cottage__detail">
                                                <p class="built-cottage__details-name">Участок:</p>
                                                <div class="built-cottage__details-count">{{item.AREA_M2}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="built-cottage__info">
                                        <p class="discount-badge" v-if="item.PROPS.SPECIAL && item.PROPS.SPECIAL[0].VALUE">{{ item.PROPS.SPECIAL[0].VALUE_TEXT}}</p>
                                        <div class="house-icons">
                                            <!-- <button class="house-icon__btn" v-if="!item.FAVORITE">
                                                <img class="house-icon__img house-icon__img-add house-icon-compare-cor"
                                                    :src="getPath('icone-favourite-add.svg')" alt="Icon">
                                            </button> -->
                                            <button class="house-icon__btn" @click.prevent.default="toggleFavorite(item)" :class="{'active': item.FAVORITE}">
                                                <img class="house-icon__img house-icon__img-add" :src="getPath('icon-heart.svg')" alt="Icon">
                                            </button>
                                        </div>
                                    </div>
       </a>
        </div>
    
</template>
